<template>
  <v-flex :class="onlyProfile === 'no' ? 'sfh-login-form background-image scrollbar scroll-style-15' : ''"
          style="padding: 10px 20px!important;">

    <v-tabs color="transparent" light slider-color="blue" :value="section">

      <!--        <v-tabs-slider v-if="onlyProfile === 'no'" color="primary darken-1"></v-tabs-slider>-->
      <v-tab ripple v-if="onlyProfile === 'no'" href="#my-profile">My Profile</v-tab>
      <v-tab ripple v-if="onlyProfile === 'no' && !isSfh()" href="#my-address">My Address</v-tab>
      <v-tab ripple v-if="onlyProfile === 'no' && !isManager" href="#update-profile">Update Password</v-tab>
      <v-tab ripple v-if="onlyProfile === 'no' && courseId === 62" href="#certificates">Certificates</v-tab>

      <v-tab-item
        value="my-profile"
      >
        <v-container grid-list-sm class="pa-0 settings-form-wrap">
          <v-layout row wrap px-0 pt-5>

            <v-flex xs12 v-if="isManager">
              <v-alert
                :value="true"
                color="error"
                icon="warning"
                outline
              >
                This store account can not modify My Profile settings
              </v-alert>
            </v-flex>

            <v-flex xs4>
              <v-avatar
                slot="activator"
                size="100,120"
                :tile=true
                color="primary"
              >
                <img :src="imageData" style="height:120px; width:100px;" alt="Avatar">
              </v-avatar>

            </v-flex>
            <v-flex xs8>
              <v-layout column>
                <v-flex d-flex xs12 style="margin-bottom: 10px;" v-if="storeDetails.storeId">
                  <v-flex xs12>
                    <v-textarea
                      label="Store Location"
                      rows="2"
                      :value="storeDetails.name + ', ' + storeDetails.address + ', ' +storeDetails.city + ', ' + storeDetails.state"
                      disabled
                    ></v-textarea>
                  </v-flex>
                </v-flex>

                <v-flex>
                  <v-text-field
                    label="E-mail"
                    :value="$store.getters['user/getUserDetails'].email"
                    disabled
                  ></v-text-field>
                </v-flex>

                <v-flex v-if="!isManager">
                  <upload-button title="Browse" :selectedCallback="fileSelectedFunc"/>

                  <!--                  <v-btn depressed small  @click="takePicture()">Camera</v-btn>-->
                </v-flex>

                <v-flex>
                </v-flex>

              </v-layout>

            </v-flex>


            <v-flex xs12 mt-4>
              <form autocomplete="off">
                <v-text-field
                  label="First Name"
                  v-validate="'required'"
                  :error-messages="errors.collect('slot1.firstName')"
                  v-model="firstName"
                  :disabled="isManager"
                  data-vv-name="slot1.firstName"
                  data-vv-scope="slot1"
                ></v-text-field>
              </form>
            </v-flex>

            <v-flex xs12>
              <form autocomplete="off">
                <v-text-field
                  label="Last Name"
                  v-validate="'required'"
                  :error-messages="errors.collect('slot1.lastName')"
                  v-model="lastName"
                  :disabled="isManager"
                  data-vv-name="slot1.lastName"
                  data-vv-validate-on="blur"
                  data-vv-scope="slot1"
                ></v-text-field>
              </form>
            </v-flex>

            <v-flex xs10>
              <v-text-field
                label="Phone"
                disabled
                v-if="!isSfh()"
                v-model="phone"
              ></v-text-field>
            </v-flex>

            <v-flex xs2 px-1>
              <v-btn
                fab
                small
                color="transparent"
                v-if="!isSfh()"
                @click="openEditPhoneDialog()"
                class="elevation-2">
                <span class="notranslate"><v-icon>edit</v-icon></span>
              </v-btn>
            </v-flex>

            <v-flex xs12 v-if="onlyProfile === 'no'">
              <v-divider class="mt-4 mb-3"></v-divider>
              <v-layout class="form-actions" row wrap justify-end>
                <v-btn flat color="secondary" class="action-btn" @click="goBack">Cancel</v-btn>
                <v-btn v-if="!isManager" color="primary" class="action-btn" :loading="loading"
                       @click="updateProfile">Update</v-btn>
              </v-layout>
            </v-flex>

            <v-flex xs12 v-if="onlyProfile !== 'no' && !isManager">
              <v-btn block @click="updateProfile" :loading="loading" color="primary">
                Update
              </v-btn>
            </v-flex>

          </v-layout>
        </v-container>
      </v-tab-item>

      <v-tab-item
        value="my-address"
      >
        <v-container grid-list-sm class="pa-0">
          <v-layout row wrap px-0 pt-5>

            <v-flex xs12>
              <form autocomplete="off">
                <v-text-field
                  label="Address line 1"
                  v-model="addressLine1"
                  v-validate="'required'"
                  :error-messages="errors.collect('slot4.addressLine1')"
                  data-vv-name="slot4.addressLine1"
                  data-vv-scope="slot4"
                ></v-text-field>
              </form>

              <form autocomplete="off">
                <v-text-field
                  label="Address line 2"
                  v-model="addressLine2"
                ></v-text-field>
              </form>

              <form autocomplete="off">
                <v-text-field
                  label="City"
                  v-model="city"
                  v-validate="'required'"
                  :error-messages="errors.collect('slot4.city')"
                  data-vv-name="slot4.city"
                  data-vv-scope="slot4"
                ></v-text-field>
              </form>

              <v-flex d-flex>
                <form autocomplete="off">
                  <v-text-field
                    label="Postal Code"
                    v-model="postalCode"
                    v-validate="'required'"
                    :error-messages="errors.collect('slot4.postalCode')"
                    data-vv-name="slot4.postalCode"
                    data-vv-scope="slot4"
                  ></v-text-field>
                </form>

                <form autocomplete="off">
                  <v-autocomplete
                    v-model="selectedCountry"
                    :items="countries"
                    item-text="name"
                    item-value="id"
                    label="Select Country"
                    @change="getStates()"
                    v-validate="'required'"
                    :error-messages="errors.collect('slot4.selectedCountry')"
                    data-vv-name="slot4.selectedCountry"
                    data-vv-scope="slot4"
                  ></v-autocomplete>
                </form>
              </v-flex>
              <form autocomplete="off">
                <v-autocomplete
                  v-model="selectedState"
                  :items="states"
                  item-text="name"
                  item-value="id"
                  label="Select State"
                  v-validate="'required'"
                  :error-messages="errors.collect('slot4.selectedState')"
                  data-vv-name="slot4.selectedState"
                  data-vv-scope="slot4"
                ></v-autocomplete>
              </form>
            </v-flex>

            <v-flex xs6 v-if="onlyProfile === 'no'">
              <v-btn block @click="goBack" color="secondary">Cancel</v-btn>
            </v-flex>

            <v-flex xs6 v-if="onlyProfile === 'no'">
              <v-btn @click="updateAddress" block :loading="loading" color="primary">Update</v-btn>
            </v-flex>

            <v-flex xs12 v-if="onlyProfile !== 'no'">
              <v-btn v-if="onlyProfile !== 'no'" block @click="updateAddress" :loading="loading" color="primary">
                Update
              </v-btn>
            </v-flex>

          </v-layout>
        </v-container>
      </v-tab-item>

      <v-tab-item
        value="certificates"
      >
        <my-certificates />
      </v-tab-item>

      <v-tab-item value="update-profile">

        <div style="overflow: hidden; height: 0px;background: transparent;"
             data-description="dummyPanel for Chrome auto-fill issue">
          <input type="text" style="height:0;background: transparent; color: transparent;border: none;"
                 data-description="dummyUsername"></input>
          <input type="password" style="height:0;background: transparent; color: transparent;border: none;"
                 data-description="dummyPassword"></input>
        </div>
        <v-layout wrap class="settings-form-wrap">

          <v-flex xs12 pt-5 px-3>
            <v-text-field
              :append-icon="e1 ? 'visibility' : 'visibility_off'"
              @click:append="() => (e1 = !e1)"
              :type="e1 ? 'password' : 'text'"
              v-validate="'required'"
              :error-messages="errors.collect('slot2.oldPassword')"
              v-model="oldPassword"
              label="Current password"
              data-vv-name="slot2.oldPassword"
              data-vv-validate-on="blur"
              data-vv-scope="slot2"
              class="notranslate"
              :onautocomplete=false
            ></v-text-field>
          </v-flex>

          <v-flex xs12 px-3>

            <v-text-field
              :append-icon="e2 ? 'visibility' : 'visibility_off'"
              @click:append="() => (e2 = !e2)"
              :type="e2 ? 'password' : 'text'"
              v-validate="'required'"
              :error-messages="errors.collect('slot2.newPassword')"
              v-model="newPassword"
              label="New password"
              data-vv-name="slot2.newPassword"
              data-vv-validate-on="blur"
              data-vv-scope="slot2"
              class="notranslate"
              :onautocomplete=false
            ></v-text-field>
          </v-flex>

          <v-flex xs12 px-3 v-if="onlyProfile === 'no'">
            <v-divider class="mt-4 mb-3"></v-divider>
            <v-layout class="form-actions" row wrap justify-end>
              <v-btn flat color="secondary" class="action-btn" @click="goBack">Cancel</v-btn>
              <v-btn color="primary" class="action-btn" :loading="loading2" @click="changePassword">Update</v-btn>
            </v-layout>
          </v-flex>

          <v-flex xs12 px-3 v-if="onlyProfile !== 'no'">
            <v-btn block @click="changePassword" :loading="loading2" color="primary">Update</v-btn>
          </v-flex>

        </v-layout>

      </v-tab-item>
    </v-tabs>

    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable

    >
      <v-card tile>
        <v-toolbar card dark color="primary">
          <v-btn icon dark @click.native="dialog = false">
            <span class="notranslate"><v-icon>close</v-icon></span>
          </v-btn>
          <v-toolbar-title>Profile image</v-toolbar-title>
        </v-toolbar>

        <v-card-text class="text-xs-center align-center justify-center">
          <vue-croppie
            style="height:450px;"
            ref=croppieRef
            :viewport="{ width: 300, height: 360, type: 'square' }"
            :enableResize="false"
            :enableOrientation="true">
          </vue-croppie>

          <v-btn @click="crop()" style="top:40px;" color="success">
            Update
          </v-btn>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>


    <v-dialog v-model="confirmIdentity" persistent max-width="400">
      <v-card>
        <v-card-title class="title primary pa-3 font-weight-light white--text" primary-title>
          <span>Confirm Identity</span>
          <v-spacer></v-spacer>
          <span class="notranslate"><v-icon dark @click="confirmIdentity = false">clear</v-icon></span>
        </v-card-title>
        <v-card-text>
          <p>We will send OTP on your registered mobile number to validate your identity.</p>
          <p>After successful OTP verification you can update your profile.</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="confirmIdentity = false">Send otp</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="phoneEditDialog" persistent max-width="400">
      <v-card>
        <v-card-title class="title primary pa-3 font-weight-light white--text" primary-title>
          <span>Update Phone</span>
          <v-spacer></v-spacer>
          <span class="notranslate"><v-icon dark @click="phoneEditDialog = false">clear</v-icon></span>
        </v-card-title>
        <v-card-text class="signup-page">


          <div v-if="update_phone_step1">
            <p>We will send OTP on your new mobile number to validate your identity.</p>
            <v-flex xs12>
              <vue-tel-input
                v-model="newPhone"
                @input="checkPhone"
                @enter="confirmMyPhone"
                :preferredCountries="['US','CA','GB']"
                :dropdownOptions="{
                    showDialCodeInSelection: true,
                    showFlags: true
                  }"
              >
                <template v-slot:arrow-icon>
                  <span></span>
                </template>
              </vue-tel-input>
              <div
                class="red--text px-3 text-xs-center"
                v-if="validPhone === false && newPhone" v-text="'Please enter valid phone number.'"/>
            </v-flex>
          </div>


          <div v-if="!update_phone_step1">
            <v-flex xs12 class="text-xs-left blue--text">
              <div>We just sent an OTP code to <span class="text-primary font-weight-bold">{{ newPhone }}</span></div>
            </v-flex>

            <v-flex d-flex xs12 mt-4>
              <v-layout row wrap align-center class="text-xs-left">
                <v-flex xs12 class="pr-4">
                  Enter the code here:
                </v-flex>

                <v-flex d-flex xs12>
                  <form autocomplete="off">
                    <v-text-field
                      @keyup="changedInput=true"
                      @keyup.enter="validateOtp"
                      v-validate="'required|length:4'"
                      :error-messages="errors.collect('slot3.otp')"
                      data-vv-name="slot3.otp"
                      data-vv-validate-on="blur"
                      v-model="otp"
                      label="Code"
                      type="tel"
                    ></v-text-field>
                  </form>
                </v-flex>
              </v-layout>
            </v-flex>
          </div>


        </v-card-text>
        <v-card-actions>
          <v-btn v-if="!update_phone_step1" @click="update_phone_step1=true;validPhone=true" color="primary">&#8592;
            Back
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn v-if="update_phone_step1"
                 :loading="updatePhoneOtpLoading"
                 color="primary"
                 @click="confirmMyPhone">Send OTP
          </v-btn>
          <v-btn
            v-if="!update_phone_step1"
            @click="validateOtp"
            :disabled="!changedInput || otp.length !== 4"
            :loading="updatePhoneLoading" class="ml-0 mr-0 "
            color="success">Confirm code
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-flex>
</template>

<script>
// https://codepen.io/ditarahma08/pen/GRRxZLW
import Vue from 'vue'
import VueCroppie from 'vue-croppie'
import VeeValidate from 'vee-validate'
import VWidget from '../widgets/VWidget'
import UploadButton from '../widgets/UploadButton'
import ThreeDots from '../widgets/ThreeDots'
// import {Camera, CameraResultType} from '@capacitor/camera'
import 'croppie/croppie.css'
import MyCertificates from './MyCertificates.vue'
import common from '../../../mixins/common'

const VueTelInput = () =>
  Promise.all([
    import(/* webpackChunkName: "chunk-vue-tel-input" */ 'vue-tel-input'),
    import(/* webpackChunkName: "chunk-vue-tel-input" */ 'vue-tel-input/dist/vue-tel-input.css')
  ]).then(([{VueTelInput}]) => VueTelInput)

Vue.use(VeeValidate)
Vue.use(VueCroppie)

function compare (a, b) {
  // Use toUpperCase() to ignore character casing
  const bandA = a.name.toUpperCase()
  const bandB = b.name.toUpperCase()

  let comparison = 0
  if (bandA > bandB) {
    comparison = 1
  } else if (bandA < bandB) {
    comparison = -1
  }
  return comparison
}

export default {
  name: 'SettingsBody',
  mixins: [common],
  props: {
    onlyProfile: {
      default: 'no',
      type: String
    }
  },
  components: {MyCertificates, ThreeDots, UploadButton, VWidget, VueTelInput},
  data: () => ({
    storeDetails: {},
    section: 'my-profile',
    badgeDetails: {},
    confirmIdentity: false,
    inputChange: false,
    loading: false,
    loading2: false,
    uname: '',
    selectedCountryTxt: '',
    phoneEditDialog: false,
    newPhone: '',
    formattedPhone: '',
    phoneObj: {},
    validPhone: null,
    changedInput: false,
    otp: '',
    phone_otp_id: '',
    update_phone_step1: true,
    updatePhoneLoading: false,
    updatePhoneOtpLoading: false,
    selectedStateTxt: '',
    countries: [],
    states: [],
    oldPassword: '',
    newPassword: '',
    disabled: false,
    apiUrl: process.env.API_URL,
    courseId: process.env.GAME_ID,
    e1: true,
    e2: true,
    dialog: false,
    dictionary: {
      custom: {
        'slot1.firstName': {
          required: () => 'First name is required'
        },
        'slot1.lastName': {
          required: () => 'Last name is required'
        },
        'slot1.phone': {
          required: () => 'Phone is required'
        },
        'slot2.oldPassword': {
          required: () => 'Current password is required'
        },
        'slot2.newPassword': {
          required: () => 'New password is required'
        },
        'slot4.country': {
          required: () => 'Country is required'
        },
        'slot4.state': {
          required: () => 'State is required'
        },
        'slot4.addressLine1': {
          required: () => 'Address line1 should not be blank'
        },
        // 'slot1.addressLine2': {
        //   required: () => 'Address line2 should not be blank'
        // },
        'slot4.city': {
          required: () => 'City should not be blank'
        },
        'slot4.postalCode': {
          required: () => 'Postal code should not be blank'
        }
      }
    }
  }),
  computed: {
    user () {
      return this.$store.getters['user/getUserDetails']
    },
    isManager () {
      return this.isSplatManager
    },
    imageData: {
      get: function () {
        return this.$store.getters['user/avatar']
      },
      set: function (newValue) {
        this.$store.commit('user/setAvatar', newValue)
      }
    },
    firstName: {
      get: function () {
        return this.$store.getters['user/getFirstName']
      },
      set: function (newValue) {
        this.$store.commit('user/setFirstName', newValue)
      }
    },
    lastName: {
      get: function () {
        return this.$store.getters['user/getLastName']
      },
      set: function (newValue) {
        this.$store.commit('user/setLastName', newValue)
      }
    },
    selectedCountry: {
      get: function () {
        return this.$store.getters['user/getCountry']
      },
      set: function (newValue) {
        this.$store.commit('user/setCountry', newValue)
      }
    },
    selectedState: {
      get: function () {
        return this.$store.getters['user/getState']
      },
      set: function (newValue) {
        this.$store.commit('user/setState', newValue)
      }
    },
    phone: {
      get: function () {
        return this.$store.getters['user/getPhone']
      },
      set: function (newValue) {
        this.$store.commit('user/setPhone', newValue)
      }
    },
    addressLine1: {
      get: function () {
        return this.$store.getters['user/getAddressLine1']
      },
      set: function (newValue) {
        this.$store.commit('user/setAddressLine1', newValue)
      }
    },
    addressLine2: {
      get: function () {
        return this.$store.getters['user/getAddressLine2']
      },
      set: function (newValue) {
        this.$store.commit('user/setAddressLine2', newValue)
      }
    },
    city: {
      get: function () {
        return this.$store.getters['user/getCity']
      },
      set: function (newValue) {
        this.$store.commit('user/setCity', newValue)
      }
    },
    postalCode: {
      get: function () {
        return this.$store.getters['user/getPostalCode']
      },
      set: function (newValue) {
        this.$store.commit('user/setPostalCode', newValue)
      }
    }
  },
  mounted () {
    if (this.$route.query.section) {
      this.section = this.$route.query.section
    }

    this.$store.commit('setIsCompactHeader', false)
    this.$validator.localize('en', this.dictionary)
    if (this.courseId === process.env.SIZZLING_PLATTER) {
      this.storeDetails = this.$store.getters['user/getCourses'][this.courseId]['stores'][0]
    }
  },
  created () {
    this.getCountries()
  },
  methods: {
    isSfh () {
      return [62, 68].includes(this.courseId)
    },
    resetPhoneEditOtpScreen () {
      this.updatePhoneOtpLoading = false
      this.otp = ''
      this.phone_otp_id = ''
    },
    openEditPhoneDialog () {
      this.phoneEditDialog = true
      this.update_phone_step1 = true
      this.newPhone = ''
      this.formattedPhone = ''
      this.phoneObj = {}
      this.validPhone = null
      this.changedInput = false
      this.update_phone_step1 = true
      this.updatePhoneLoading = false
    },
    validateOtp () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.updatePhoneLoading = true
          const otpId = this.phone_otp_id
          this.$http({
            url: process.env.API_URL + '/ws/userservice/verify/otp/' + otpId + '/entered/' + this.otp,
            method: 'GET'
          }).then((res) => {
            if (res.data.otpMatch === true) {
              this.updatePhone()
            } else {
              this.updatePhoneLoading = false
              this.errors.add({
                field: 'slot3.otp',
                msg: 'Invalid code'
              })
            }
          })
        }
      })
    },
    updatePhone () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$http({
            url: process.env.API_URL + `/ws/playerservice/phone/user/${this.user.id}/course/${this.courseId}`,
            method: 'POST',
            headers: {
              Authorization: 'Bearer ' + this.$auth.token(),
              'Content-Type': 'application/json'
            },
            data: {
              phoneNumber: '+' + this.formattedPhone,
              phoneOtpId: this.phone_otp_id
            }
          }).then((res) => {
            this.updatePhoneLoading = false
            if (res) {
              this.phoneEditDialog = false
              this.$store.commit('user/setPhone', '+' + this.formattedPhone)
              this.$store.commit('flashSuccess', 'Phone number updated successfully.')
            }
          }).catch(e => {
            this.errors.add({
              field: 'slot3.otp',
              msg: e.message
            })
          })
        }
      })
    },
    checkPhone (phoneNUmber, payload) {
      this.formattedPhone = payload.countryCallingCode + '' + payload.nationalNumber
      this.validPhone = !!payload.valid
    },
    confirmMyPhone () {
      if (!this.validPhone) {
        return
      }

      this.updatePhoneOtpLoading = true
      this.$store.dispatch('registration/sendOtpOnPhone', this.formattedPhone)
        .then((res) => {
          if (res) {
            this.resetPhoneEditOtpScreen()
            this.update_phone_step1 = false
            this.validPhone = true
            this.phone_otp_id = res.data.otpId
          } else {
            this.errors.add({
              scope: 'slot1',
              field: 'phone',
              msg: 'Unexpected error'
            })
          }
          this.updatePhoneOtpLoading = false
        })
    },
    goBack () {
      window.history.back(-1)
    },
    getCountries () {
      this.$http({
        url: process.env.API_URL + '/ws/userservice/country',
        method: 'GET'
      }).then((res) => {
        this.countries = res.data.countries
        this.states = res.data.usa.sort(compare)
        if (this.selectedCountry) {
          this.getStates()
        }
      })
    },
    getStates () {
      this.$http({
        url: process.env.API_URL + '/ws/userservice/country/' + this.selectedCountry + '/state',
        method: 'GET'
      }).then((res) => {
        // this.countries = res.data.countries
        this.states = res.data.states.sort(compare)
      })
    },
    /**
     * Convert a base64 string in a Blob according to the data and contentType.
     *
     * @param b64Data {String} Pure base64 string without contentType
     * @param contentType {String} the content type of the file i.e (image/jpeg - image/png - text/plain)
     * @param sliceSize {Int} SliceSize to process the byteCharacters
     * @see http://stackoverflow.com/questions/16245767/creating-a-blob-from-a-base64-string-in-javascript
     * @return Blob
     */
    b64toBlob (b64Data, contentType, sliceSize) {
      contentType = contentType || ''
      sliceSize = sliceSize || 512

      let byteCharacters = atob(b64Data)
      let byteArrays = []

      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        let slice = byteCharacters.slice(offset, offset + sliceSize)

        let byteNumbers = new Array(slice.length)
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i)
        }

        let byteArray = new Uint8Array(byteNumbers)

        byteArrays.push(byteArray)
      }

      return new Blob(byteArrays, {type: contentType})
    },
    afterImageLoaded (imageData) {
      // Split the base64 string in data and contentType
      let block = imageData.split(';')
      // Get the content type of the image
      let contentType = block[0].split(':')[1]// In this case "image/gif"
      // get the real base64 content of the file
      let realData = block[1].split(',')[1]// In this case "R0lGODlhPQBEAPeoAJosM...."

      // Convert it to a blob to upload
      let blob = this.b64toBlob(realData, contentType)
      let data = new window.FormData()
      data.append('avatar', blob)
      const url = this.isSfh() ? `${this.apiUrl}/ws/playerservice/user/${this.user.id}/blob` : `${this.apiUrl}/ws/playerservice/user/${this.user.id}/blob?deck=${process.env.GAME_ID}`
      return this.$http({
        url,
        headers: {
          Authorization: 'Bearer ' + this.$auth.token(),
          'Content-Type': 'multipart/form-data'
        },
        method: 'POST',
        data
      })
    },
    crop () {
      let options = {
        format: 'jpeg',
        circle: false
      }
      this.$refs.croppieRef.result(options, async (output) => {
        this.imageData = output
        this.dialog = false
        await this.afterImageLoaded(output).then((res) => {
          this.screenShotFileName = res.data
        }).catch(e => {
          this.$store.commit('flashError', e.message)
        })
      })
    },
    rotate (rotationAngle) {
      this.$refs.croppieRef.rotate(rotationAngle)
    },
    fileSelectedFunc: function (event) {
      let input = event.target
      if (input.files && input.files[0]) {
        let reader = new FileReader()
        reader.onload = (e) => {
          this.$refs.croppieRef.bind({
            url: e.target.result
          })
          this.dialog = true
        }
        reader.readAsDataURL(input.files[0])
      }
    },
    updateProfile () {
      this.$validator.validateAll('slot1').then((result) => {
        if (result) {
          this.loading = true
          this.$http({
            url: `${this.apiUrl}/ws/playerservice/profile/user/${this.user.id}`,
            method: 'POST',
            headers: {
              Authorization: 'Bearer ' + this.$auth.token()
            },
            data: {
              firstName: this.firstName,
              lastName: this.lastName
            }
          }).then((res) => {
            this.$store.commit('flashSuccess', 'Profile updated successfully.')
            if (this.onlyProfile === 'no') {
              this.goBack()
            } else {
              this.$store.commit('setSettingsDrawer', false)
            }
          }).catch(e => {
            this.$store.commit('flashError', e.message)
          }).finally(() => {
            this.loading = false
          })
        } else {
          this.loading = false
        }
      })
    },
    updateAddress () {
      this.$validator.validateAll('slot4').then((result) => {
        if (result) {
          this.loading = true
          this.$http({
            url: `${this.apiUrl}/ws/playerservice/address/user/${this.user.id}/course/${this.courseId}`,
            method: 'POST',
            headers: {
              Authorization: 'Bearer ' + this.$auth.token()
            },
            data: {
              addressLine1: this.addressLine1,
              addressLine2: this.addressLine2,
              city: this.city,
              countryId: this.selectedCountry,
              stateId: this.selectedState,
              postalCode: this.postalCode
            }
          }).then((res) => {
            this.$store.commit('flashSuccess', 'Address updated successfully.')
            if (this.onlyProfile === 'no') {
              this.goBack()
            } else {
              this.$store.commit('setSettingsDrawer', false)
            }
          }).catch(e => {
            this.$store.commit('flashError', e.message)
          }).finally(() => {
            this.loading = false
          })
        } else {
          this.loading = false
        }
      })
    },
    changePassword () {
      this.errors.clear('slot2')
      this.$validator.validateAll('slot2').then((result) => {
        if (result) {
          this.loading2 = true
          this.$http({
            url: `${this.apiUrl}/ws/userservice/password`,
            method: 'POST',
            data: {
              existingPassword: this.oldPassword,
              newPassword: this.newPassword,
              username: this.user.email
            }
          }).then((res) => {
            this.$store.commit('flashSuccess', 'Password changed successfully.')
            this.goBack()
          }).catch(e => {
            this.$store.commit('flashError', e.message)
            this.errors.add({
              scope: 'slot2',
              field: 'oldPassword',
              msg: 'Current password isn\'t correct. If you don\'t remember then use Forgot Password.'
            })
          }).finally(() => {
            this.loading2 = false
          })
        } else {
          this.loading2 = false
        }
      })
    }
  },
  watch: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.v-dialog--scrollable > .v-card > .v-card__text {
  overflow-y: visible;
}

.settings-form-wrap {
  width: 100%;
  max-width: 720px;
  margin: 0 auto;
}
.form-actions .action-btn {
  min-width: 140px;
}
@media (max-width: 599px) {
  .form-actions .action-btn {
    width: 100%;
    margin-left: 0;
    margin-right: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/auth/SettingsBody.vue